export default "__VITE_ASSET__4ef17760__"